import {
  isProOrAbove,
  normalizePackageTierCode,
} from "./packageTier";

const PACKAGE_ID_TO_CODE = {
  1: "BASIC",
  2: "PRO",
  3: "AGENCY",
  4: "TRIAL",
};

function normalizePackageCode(value) {
  if (value == null) return "";
  const raw = String(value).trim().toUpperCase();
  if (!raw) return "";
  if (/^\d+$/.test(raw)) {
    const mapped = PACKAGE_ID_TO_CODE[Number(raw)];
    return mapped || "";
  }
  return normalizePackageTierCode(raw);
}

function normalizeSubscriptionStatus(value) {
  return String(value || "").trim().toLowerCase();
}

function packageNameHeFromCode(code) {
  if (code === "PRO") return "PRO";
  if (code === "BASIC") return "BASIC";
  if (code === "AGENCY") return "סוכנות";
  if (code === "TRIAL") return "ניסיון 60 יום";
  return "";
}

function isActiveSubscriptionStatus(status) {
  return (
    status === "active_paid" ||
    status === "trial_active" ||
    status === "approved_trial_active" ||
    status === "active"
  );
}

export function resolveAgentDisplayedPackage({
  resolvedPackage,
} = {}) {
  const code = normalizePackageCode(
    resolvedPackage?.code ?? resolvedPackage?.packageCode
  );
  const resolutionStatus = String(
    resolvedPackage?.resolutionStatus ?? ""
  )
    .trim()
    .toLowerCase();
  const subscriptionStatus = normalizeSubscriptionStatus(
    resolvedPackage?.subscriptionStatus ?? resolvedPackage?.status
  );
  const explicitName = String(
    resolvedPackage?.name ?? resolvedPackage?.packageName ?? ""
  ).trim();

  const missingAssignment = resolutionStatus === "missing_package_assignment";

  let packageNameHe = "";
  if (code) {
    packageNameHe = packageNameHeFromCode(code);
  } else if (missingAssignment) {
    packageNameHe = "טרם שויכה חבילה";
  } else {
    packageNameHe = explicitName || packageNameHeFromCode(code);
    if (!packageNameHe) {
      packageNameHe = "לא הוגדרה חבילה";
    }
  }

  return {
    packageCode: code,
    packageNameHe,
    status: subscriptionStatus,
    resolutionStatus,
    missingPackageAssignment: missingAssignment,
    isActive: isActiveSubscriptionStatus(subscriptionStatus),
    source: "resolved_package",
  };
}

export function shouldShowUpgradeCta({
  resolvedPackageCode,
  subscriptionStatus,
  showBillingMigrationGate,
} = {}) {
  const code = normalizePackageCode(resolvedPackageCode);
  const status = normalizeSubscriptionStatus(subscriptionStatus);
  if (showBillingMigrationGate) return false;
  if (isProOrAbove(code)) return false;
  if (!code) return false;
  // TRIAL / BASIC — אפשר לשדרג לחבילה בתשלום
  return (
    status === "trial_active" ||
    status === "approved_trial_active" ||
    status === "pending_manual_approval" ||
    status === "active_paid" ||
    status === "past_due"
  );
}

